import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TeamMemberServiceInterface } from './team-member.interface';
import { DropdownOption } from '@cms/shared-library';
import { TpTeamMemberModel } from 'src/app/models/team-member.model';
import { DSAReplacementDTO } from 'src/app/models/dsa-replacement-dto';
import { CourseSchedule } from 'src/app/models/course-schedule';
import { DeleteTeamMemberRequest } from 'src/app/models/delete-team-member-request.model';

@Injectable({
  providedIn: 'root'
})
export class TeamMemberService implements TeamMemberServiceInterface {

  constructor(private httpClient: HttpClient) {
  }

  GetAllTeamMembers(): Observable<any> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `TeamMember/GetAllTeamMembers`);
  }

  GetAllTeamMembersWithRoles(): Observable<any> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `TeamMember/GetAllTeamMembersWithRoles`);
  }

  GetAllPublicRoles(): Observable<DropdownOption[]> {
    return this.httpClient.get<DropdownOption[]>(environment.apiBaseUrl + `TeamMember/GetAllPublicRoles`).pipe(map(this.roleMapper));
  }

  SaveTrainingProviderTeamMember(teamMember: TpTeamMemberModel): Observable<string> {
    return this.httpClient.post<any>(environment.apiBaseUrl + `TeamMember/SaveTrainingProviderTeamMember`, teamMember);
  }

  GetTeamMemberInfoByMemberId(memberId: string): Observable<any> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `TeamMember/GetTeamMemberInfoByMemberId/${memberId}`);
  }

  GetAllOrganizationsByTrainingProviderId(): Observable<string[]> {
    return this.httpClient.get<string[]>(environment.apiBaseUrl + `TeamMember/GetAllOrganizationsByTrainingProviderId`);
  }

  IsTeamMemberEmailExist(email: string): Observable<{isActiveEmailExist: boolean, deletedTeamMemberId: string}> {
    return this.httpClient.post<{isActiveEmailExist: boolean, deletedTeamMemberId: string}>(environment.apiBaseUrl + `TeamMember/IsTeamMemberEmailExist`, {'email': email}, {reportProgress: true});
  }

  DeleteTeamMembers(memberList: DeleteTeamMemberRequest): Observable<boolean> {
    return this.httpClient.post<boolean>(environment.apiBaseUrl + `TeamMember/DeleteTeamMembers`,  memberList);
  }

  DeleteAndReplaceDSA(person: DSAReplacementDTO): Observable<boolean>{
    return this.httpClient.post<boolean>(environment.apiBaseUrl + `TeamMember/ReplaceAndDeleteDSA`, person);
  }

  GetActiveClassesWithTeamMemberAsInstructor(memberId: string): Observable<CourseSchedule[]>{
    return this.httpClient.get<CourseSchedule[]>(environment.apiBaseUrl + `TeamMember/GetActiveClassesForInstructor/${memberId}`);
  }

  private roleMapper = (dropdowns: any[]) => {
    return dropdowns.map(x => new DropdownOption(x.Name, x.NameFr, x.Value))
  };

}
